import { Feature } from '@tencent/workbench';
import ChartBaseDrawerFeature from '../../chart-base-drawer-feature';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ISubChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart';
import { STSizeRepresents, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { IBarChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/bar-chart.interface';
import { AngleFrom, NumberInputFrom } from '@tencent/wb-ext-form';
import { handleInputBlurInitAndReset, IInputParams } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { IPieChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/pie-chart.interface';
import { IDoughnutChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/doughnut-chart.interface';
import { IBubbleChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/bubble-chart.interface';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { ISeriesOptionsFeature } from '@tencent/chart-drawer-components/lib/interface';
import { SizeRepresent } from '@tencent/chart-drawer-components/lib/config';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';


@Feature({
    name: 'SeriesOptionsFeature',
    adapters: [SLIDE_ADAPTER],
    provide: ISeriesOptionsFeature,
})
export class SeriesOptionsFeature extends ChartBaseDrawerFeature implements ISeriesOptionsFeature {
    private curBubbleSizeRepresent: string;

    public getSelectSubChart(): ISubChartProperty | undefined {
        const model = super.getSelectModel() as IChartModel;
        if (model?.type === UIModelType.CHART && model.selectedElement) {
            const subChart =  model.getSelectedSubChartProperty();
            if (!subChart) return ;
            return subChart;
        }
        return;
    }

    public getChartOriginType(): SubChartType | undefined {
        const subChart = this.getSelectSubChart();
        if (!subChart) return ;
        return subChart.getChartOriginType();
    }

    public updateSeriesOverlap(value: number, onlyChangeUI?: boolean) {
        const orignType = this.getChartOriginType();
        if (!orignType || orignType !== SubChartType.BarChart) return;
        const subChart = this.getSelectSubChart() as IBarChartProperty;
        if (!subChart) return;
        subChart.updateSeriesOverlap(value, onlyChangeUI);
    }

    @handleInputBlurInitAndReset()
    public handelSeriesOverlapChange(value: number, from?: NumberInputFrom, dragEnd?: boolean): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            const subChart = this.getSelectSubChart() as IBarChartProperty;
            if (value === subChart?.overlap) return;
            this.updateSeriesOverlap(value, onlyChangeUI);
        } else {
            this.updateSeriesOverlap(value, onlyChangeUI);
        }
    }

    public updateGapWidth(value: number, onlyChangeUI?: boolean) {
        const origenType = this.getChartOriginType();
        if (origenType !== SubChartType.BarChart && origenType !== SubChartType.Bar3DChart) return;
        const subChart = this.getSelectSubChart() as IBarChartProperty;
        if (!subChart) return;
        subChart.updateGapWidth(value, onlyChangeUI);
    }

    @handleInputBlurInitAndReset()
    public handelGapWidthChange(value: number, from?: NumberInputFrom, dragEnd?: boolean): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            const subChart = this.getSelectSubChart() as IBarChartProperty;
            if (value === subChart?.gapWidth) return;
            this.updateGapWidth(value, onlyChangeUI);
        } else {
            this.updateGapWidth(value, onlyChangeUI);
        }
    }

    // 饼图与圆环图
    public updateAngleOfFirstSlice(value: number, onlyChangeUI?: boolean) {
        const origenType = this.getChartOriginType();
        if (origenType === SubChartType.PieChart
            || origenType === SubChartType.Pie3DChart
            || origenType === SubChartType.DoughnutChart) {
            const subChart = this.getSelectSubChart() as IPieChartProperty | IDoughnutChartProperty;
            if (!subChart) return;
            subChart.updateAngleOfFirstSlice(value, onlyChangeUI);
        }
    }

    @handleInputBlurInitAndReset()
    public handelPieAngleOfFirstSliceChange(value: number, from?: AngleFrom, dragEnd?: boolean) {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            const subChart = this.getSelectSubChart() as IPieChartProperty | IDoughnutChartProperty;
            if (value === subChart?.firstSliceAngle) return;
            this.updateAngleOfFirstSlice(value, onlyChangeUI);
        } else {
            this.updateAngleOfFirstSlice(value, onlyChangeUI);
        }
    }

    public updateDoughnutHoleSize(value: number, onlyChangeUI?: boolean) {
        const origenType = this.getChartOriginType();
        if (origenType !== SubChartType.DoughnutChart) return;
        const subChart = this.getSelectSubChart() as IDoughnutChartProperty;
        if (!subChart) return;
        subChart.updateDoughnutHoleSize(value, onlyChangeUI);
    }

    @handleInputBlurInitAndReset()
    public handelDoughnutHoleSizeChange(value: number, from?: NumberInputFrom, dragEnd?: boolean): void {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        if (from === NumberInputFrom.INPUT) {
            if (onlyChangeUI) return;
            const subChart = this.getSelectSubChart() as IDoughnutChartProperty;
            if (value === subChart.holeSize) return;
            this.updateDoughnutHoleSize(value, onlyChangeUI);
        } else {
            this.updateDoughnutHoleSize(value, onlyChangeUI);
        }
    }

    // 气泡图相关操作
    public setBubbleSizeRepresent(value: string) {
        this.curBubbleSizeRepresent = value;
    }

    public handelBubbleSizeRepresentChange() {
        const updateStyleMap = {
            [SizeRepresent.area]: () => this.updateBubbleSizeRepresent(STSizeRepresents.area),
            [SizeRepresent.w]: () => this.updateBubbleSizeRepresent(STSizeRepresents.w),
        };
        updateStyleMap[this.curBubbleSizeRepresent]?.();
    }

    public updateBubbleSizeRepresent(value: STSizeRepresents) {
        const origenType = this.getChartOriginType();
        if (origenType !== SubChartType.BubbleChart) return;
        const subChart = this.getSelectSubChart() as IBubbleChartProperty;
        subChart.updateBubbleSizeRepresent(value);
    }

    public getInputParams(): IInputParams {
        return {
            key: INPUT_PROPS_CALLBACK_KEY.CHART_SERIES_OPTIONS,
        };
    }
}
